angular.module('impactx.approval').controller('ApprovalListOpenCtrl', [
    '$scope',
    '$rootScope',
    'selectedListItems',
    '$redirect',
    '$controller',
    '$mdDialog',
    'dataGen',
    'ToastService',
    'TranslationService',
    '$route',
    ApprovalListOpenCtrl]);

function ApprovalListOpenCtrl($scope, $rootScope, selectedListItems, $redirect, $controller, $mdDialog, dataGen, ToastService, TranslationService, $route) {
    var mainCtrl = $controller('ApprovalListCtrl', {
        selectedListItems: selectedListItems,
        $redirect: $redirect,
        $mdDialog: $mdDialog
    });
    var budget = 7;
    var ctrl = this;

    this.approveAll = function () {
        var itemsToSend = [];
        var selectedItems = selectedListItems.getSelectedItems();
        for (var i = 0; i < selectedItems.length; i++) {
            itemsToSend.push(ctrl.getActionData(selectedItems[i]));
        }
        return dataGen.postAsForm($scope, {items: itemsToSend}, "/approval/approve/all").then(function () {
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            $route.reload();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    this.showApprovalStopOrDenyDialog = function (event, title, saveLabel) {
        return $mdDialog.show({
            controller: "ApprovalDenyOrStopCommentController",
            controllerAs: "approvalDenyOrStopCommentController",
            templateUrl: "modules/approval/templates/approval-deny-or-stop-comment.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                title: title,
                saveLabel: saveLabel
            }
        })
    };

    this.denyAll = function (event, trns) {
        var itemsToSend = [];
        var selectedItems = selectedListItems.getSelectedItems();
        for (var i = 0; i < selectedItems.length; i++) {
            itemsToSend.push(ctrl.getActionData(selectedItems[i]));
        }
        ctrl.showApprovalStopOrDenyDialog(event, trns.approvalComment, trns.denyAll).then(function (answer) {
            for (var i = 0; i < itemsToSend.length; i++) {
                itemsToSend[i].newComment = answer;
            }
            dataGen.postAsForm($scope, {items: itemsToSend}, "/approval/deny/all").then(function () {
                selectedListItems.unselectAll(selectedItems);
                $rootScope.$broadcast('list:resetPageSelection');
                $route.reload();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            });
        });
    };

    this.stopAll = function (event, trns) {
        var selectedItems = selectedListItems.getSelectedItems();
        const selected = selectedListItems.getFirstSelectedItem();
        const dataObj = ctrl.getActionData(selected);
        ctrl.showApprovalStopOrDenyDialog(event, trns.approvalComment, trns.stopAll).then(function (answer) {
            dataObj.newComment = answer;
            dataGen.post($scope, dataObj, "/approval/stop").then(function () {
                selectedListItems.unselectAll(selectedItems);
                $rootScope.$broadcast('list:resetPageSelection');
                $route.reload();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            });
        });
    };

    this.delegateAll = function(ev) {
        var selectedItems = selectedListItems.getSelectedItems();
        const selected = selectedListItems.getFirstSelectedItem();
        var dataObj = ctrl.getActionData(selected);
        $mdDialog.show({
            controller: 'DelegationUserController',
            templateUrl: 'modules/approval/templates/delegationuser.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                selectionData: dataObj,
                entryPoint: ctrl.getDelegationUserEntryPoint()
            }
        }).then(function (answer) {
            if (answer !== false) {
                dataObj.delegationUserId = answer.id;
                dataGen.post($scope, dataObj, "/approval/delegate").then(function () {
                    selectedListItems.unselectAll(selectedItems);
                    $rootScope.$broadcast('list:resetPageSelection');
                    $route.reload();
                    ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                });
            }
        });
    };

    this.getDelegationUserEntryPoint = function() {
        return "/approval/delegationuser";
    };

    ctrl.getActionData = function (selected) {
        if (selected.type == mainCtrl.TYPE_PRH) {
            return {
                PRH_Id: selected.headerId,
                type: "prh",
                id: selected.id
            };
        }
        else if (selected.type == mainCtrl.TYPE_DEH) {
            return {
                DEH_Id: selected.headerId,
                type: "deh",
                id: selected.id
            };
        }
        else if (selected.type == mainCtrl.TYPE_BUDGET) {
            return {
                BUD_Id: selected.headerId,
                type: "bud",
                id: selected.id
            };
        }
    };

    this.markAsRead = function () {
        var selectedItems = selectedListItems.getSelectedItems();
        let dataForItemAction = ctrl.getDataForItemAction();
        dataGen.postAsForm($scope, dataForItemAction, "/approval/approvalview").then(function () {
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            $route.reload();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    }

    this.canMarkAsRead = function () {
        var canMarkAsRead = false;
        if (selectedListItems.isSingleSelection() || selectedListItems.isMultiSelection()) {
            canMarkAsRead = true;
            let selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i].approvalTypeFilter.icon === 'approval') {
                    canMarkAsRead = false;
                }
            }

        }
        return canMarkAsRead;
    }

    this.getDataForItemAction = function () {
        return {
            data: {
                PRH_Ids: selectedListItems.getSelectedItems().map(item => item.headerId),
                type: "prh",
                id: 0
            }
        };
    };

    this.canApproveAll = function () {
        var canApprove = false;
        if (selectedListItems.isMultiSelection()) {
            canApprove = true;
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (!selectedItems[i].canApprove.value) {
                    canApprove = false;
                    break;
                }
            }
        }
        return canApprove;
    };

    this.canDenyAll = function () {
        var canDeny = false;
        if (selectedListItems.isMultiSelection()) {
            canDeny = true;
            var selectedItems = selectedListItems.getSelectedItems();
            for (var i = 0; i < selectedItems.length; i++) {
                if (!selectedItems[i].canDeny.value) {
                    canDeny = false;
                    break;
                }
            }
        }
        return canDeny;
    };

    this.canStopAll = function ()  {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canStop.value && selectedListItems.getFirstSelectedItem().type != budget;
    };

    this.canDelegateAll = function ()  {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDelegate.value;
    };

    this.canJumpToContractChangeList = function () {
        return impactX.isDefined($scope, '$$childHead.data.actions.canJumpToContractChangeList.allowed');
    };

    this.getContractChangeListLink = function () {
        return 'contractchangelist';
    };

    var buttonDefinition = [
        {
            label: "details",
            action: mainCtrl.redirectToDetail,
            type: 'dialogaction',
            condition: selectedListItems.isSingleSelection,
            process: 'ApprovalList'
        },
        {
            label: "approveAll",
            action: ctrl.approveAll,
            type: 'dialogaction',
            condition: ctrl.canApproveAll,
            process: 'ApprovalList'
        },
        {
            label: "markAsRead",
            action: ctrl.markAsRead,
            type: 'dialogaction',
            condition: ctrl.canMarkAsRead,
            process: 'ApprovalList'
        },
        {
            label: "denyAll",
            action: ctrl.denyAll,
            type: 'dialogaction',
            condition: ctrl.canDenyAll,
            process: 'ApprovalList'
        },
        {
            label: "stopAll",
            action: ctrl.stopAll,
            type: 'dialogaction',
            condition: ctrl.canStopAll,
            process: 'ApprovalList'
        },
        {
            label: "delegate",
            action: ctrl.delegateAll,
            type: 'dialogaction',
            condition: ctrl.canDelegateAll,
            process: 'ApprovalList'
        },
        {
            label: "contractchangelist",
            linkFunction: ctrl.getContractChangeListLink,
            type: 'link',
            condition: ctrl.canJumpToContractChangeList,
            process: 'ApprovalList'
        }
    ];

    function getItemExpansionParamsFunction(row) {
        return {atiId: row.id};
    }

    mainCtrl.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/approval/templates/approvallist.row.tmpl.html',
        filtersTemplate: 'modules/approval/templates/approvallist.filters.tmpl.html',
        isSelectAble: true,
        endpoint: '/approval/list/open',
        ctrl: mainCtrl,
        id: "approvallist",
        excelExport: true,
        itemExpansion: {
            entryPoint: '/approval/atioverview',
            paramsFunction: getItemExpansionParamsFunction,
            templateUrl: 'modules/approval/templates/approval-itemexpansion.html',
            canExpandFunction: mainCtrl.canExpand
        }
    };
    this.getMeta = function() {
        return mainCtrl.meta;
    };

    mainCtrl.status = "open";
    $scope.$watch(function() {
        return mainCtrl.status;
    }, function(current, original) {
        if(current == "done")
            $redirect.redirectTo(null, "/approvallistdone");
    });
}